import { render, staticRenderFns } from "./CostEcon.vue?vue&type=template&id=1f2a55b7&"
import script from "./CostEcon.vue?vue&type=script&lang=js&"
export * from "./CostEcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports